// Core
import { Text, Flex, Box } from '@chakra-ui/react';

// Assets
import {
	plansItemColor,
	plansItemIconBgColor
} from 'services/Utils';

// Components
import { CheckActiveIcon} from 'components/Icons/Icons';
import IconBox from "components/Icons/IconBox";

const MembershipPetrolInclusionsItem = ({ title, description, isDark, type, icon, iconP}) => {
    return (
    	<Flex gap="8px" mb="10px">
    		<Box 
    			bg={plansItemIconBgColor(type)} borderRadius="full" w="20px" h="20px" p={ iconP ?? '3px'}>
	    		<IconBox color="white">{icon}</IconBox>
           	</Box>
			<Text><span style={{ 
				color: plansItemColor(type), 
				fontWeight: '600', 
				fontStyle: 'italic' }}>{title}</span> {description}</Text>
		</Flex>
	);
};

export default MembershipPetrolInclusionsItem;